// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";

import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { sizes, typeSet, borderRadius } from "../../helpers/theme";

import {
  XYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  AreaSeries,
  GradientDefs,
  DiscreteColorLegend
} from "react-vis";

var tinycolor = require("tinycolor2");
var chroma = require("chroma-js");
var $ = require("jquery");

let GraphStyles = props => css`
  width: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
  // Hide Scrollbars
  -ms-overflow-style: none !important;
  overflow: -moz-scrollbars-none !important;
  overscroll-behavior-y: contain;
  &::-webkit-scrollbar {
    display: none !important;
  }

  .rv-radial-chart {
    margin: 0 auto;
  }

  .react-vis-magic-css-import-rule {
    display: inherit;
  }
  .rv-treemap {
    font-size: 12px;
    position: relative;
  }
  .rv-treemap__leaf {
    overflow: hidden;
    position: absolute;
  }
  .rv-treemap__leaf--circle {
    align-items: center;
    border-radius: 100%;
    display: flex;
    justify-content: center;
  }
  .rv-treemap__leaf__content {
    overflow: hidden;
    padding: 10px;
    text-overflow: ellipsis;
  }
  .rv-xy-plot {
    color: #c3c3c3;
    position: relative;
  }
  .rv-xy-plot canvas {
    pointer-events: none;
  }
  .rv-xy-plot .rv-xy-canvas {
    pointer-events: none;
    position: absolute;
  }
  .rv-xy-plot__inner {
    display: block;
  }
  .rv-xy-plot__axis__line {
    fill: none;
    stroke-width: 2px;
    stroke: #e6e6e9;
  }
  .rv-xy-plot__axis__tick__line {
    stroke: #e6e6e9;
  }
  .rv-xy-plot__axis__tick__text {
    fill: #6b6b76;
    font-size: 11px;
  }
  .rv-xy-plot__axis__title text {
    fill: #6b6b76;
    font-size: 11px;
  }
  .rv-xy-plot__grid-lines__line {
    stroke: #e6e6e9;
  }
  .rv-xy-plot__circular-grid-lines__line {
    fill-opacity: 0;
    stroke: #e6e6e9;
  }
  .rv-xy-plot__series,
  .rv-xy-plot__series path {
    pointer-events: all;
  }
  .rv-xy-plot__series--line {
    fill: none;
    stroke: #000;
    stroke-width: 2px;
  }
  .rv-crosshair {
    position: absolute;
    font-size: 11px;
    pointer-events: none;
  }
  .rv-crosshair__line {
    background: #47d3d9;
    width: 1px;
  }
  .rv-crosshair__inner {
    position: absolute;
    text-align: left;
    top: 0;
  }
  .rv-crosshair__inner__content {
    border-radius: 4px;
    background: #3a3a48;
    color: #fff;
    font-size: 12px;
    padding: 7px 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
  .rv-crosshair__inner--left {
    right: 4px;
  }
  .rv-crosshair__inner--right {
    left: 4px;
  }
  .rv-crosshair__title {
    font-weight: bold;
    white-space: nowrap;
  }
  .rv-crosshair__item {
    white-space: nowrap;
  }
  .rv-hint {
    position: absolute;
    pointer-events: none;
  }
  .rv-hint__content {
    border-radius: 4px;
    padding: 7px 10px;
    font-size: 12px;
    background: #3a3a48;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: left;
    white-space: nowrap;
  }
  .rv-discrete-color-legend {
    box-sizing: border-box;
    overflow-y: auto;
    font-size: 12px;
  }
  .rv-discrete-color-legend.horizontal {
    white-space: nowrap;
  }
  .rv-discrete-color-legend-item {
    color: #3a3a48;
    border-radius: 1px;
    padding: 9px 10px;
  }
  .rv-discrete-color-legend-item.horizontal {
    display: inline-block;
  }
  .rv-discrete-color-legend-item.horizontal
    .rv-discrete-color-legend-item__title {
    margin-left: 0;
    display: block;
  }
  .rv-discrete-color-legend-item__color {
    display: inline-block;
    vertical-align: middle;
    overflow: visible;
  }
  .rv-discrete-color-legend-item__color__path {
    stroke: #dcdcdc;
    stroke-width: 2px;
  }
  .rv-discrete-color-legend-item__title {
    margin-left: 10px;
  }
  .rv-discrete-color-legend-item.disabled {
    color: #b8b8b8;
  }
  .rv-discrete-color-legend-item.clickable {
    cursor: pointer;
  }
  .rv-discrete-color-legend-item.clickable:hover {
    background: #f9f9f9;
  }
  .rv-search-wrapper {
    display: flex;
    flex-direction: column;
  }
  .rv-search-wrapper__form {
    flex: 0;
  }
  .rv-search-wrapper__form__input {
    width: 100%;
    color: #a6a6a5;
    border: 1px solid #e5e5e4;
    padding: 7px 10px;
    font-size: 12px;
    box-sizing: border-box;
    border-radius: 2px;
    margin: 0 0 9px;
    outline: 0;
  }
  .rv-search-wrapper__contents {
    flex: 1;
    overflow: auto;
  }
  .rv-continuous-color-legend {
    font-size: 12px;
  }
  .rv-continuous-color-legend .rv-gradient {
    height: 4px;
    border-radius: 2px;
    margin-bottom: 5px;
  }
  .rv-continuous-size-legend {
    font-size: 12px;
  }
  .rv-continuous-size-legend .rv-bubbles {
    text-align: justify;
    overflow: hidden;
    margin-bottom: 5px;
    width: 100%;
  }
  .rv-continuous-size-legend .rv-bubble {
    background: #d8d9dc;
    display: inline-block;
    vertical-align: bottom;
  }
  .rv-continuous-size-legend .rv-spacer {
    display: inline-block;
    font-size: 0;
    line-height: 0;
    width: 100%;
  }
  .rv-legend-titles {
    height: 16px;
    position: relative;
  }
  .rv-legend-titles__left,
  .rv-legend-titles__right,
  .rv-legend-titles__center {
    position: absolute;
    white-space: nowrap;
    overflow: hidden;
  }
  .rv-legend-titles__center {
    display: block;
    text-align: center;
    width: 100%;
  }
  .rv-legend-titles__right {
    right: 0;
  }
  .rv-radial-chart .rv-xy-plot__series--label {
    pointer-events: none;
  }
  .radar-chart {
  }
  .rv-xy-plot__series--label-text {
    fill: ${props.theme.colors.secondary};
    ${typeSet(sizes.fontSize * 0.75)}
  }
  .rv-xy-plot__circular-grid-lines__line {
    stroke: ${tinycolor(props.theme.colors.secondary)
      .setAlpha(0.2)
      .toString()};
  }
  .rv-xy-plot__axis__line,
  .rv-xy-plot__axis__tick__line {
    stroke: ${tinycolor(props.theme.colors.secondary)
      .setAlpha(0.4)
      .toString()};
  }

  // Line-Chart
  .rv-xy-plot__axis__tick__text {
    fill: ${props.theme.colors.secondary};
    ${typeSet(sizes.fontSize * 0.75)}
  }
  .rv-xy-plot__axis__line {
    stroke: ${tinycolor(props.theme.colors.secondary)
      .setAlpha(0.4)
      .toString()};
  }
  .rv-xy-plot__grid-lines__line {
    stroke: ${tinycolor(props.theme.colors.secondary)
      .setAlpha(0.2)
      .toString()};
  }
  .rv-xy-plot__series--line {
    stroke-width: 2px;
  }
  .rv-xy-plot__axis__title text {
    fill: ${props.theme.colors.secondary};
    ${typeSet(sizes.fontSize * 0.75)}
  }
`;
export let GraphStyled = styled("div")`
  ${GraphStyles}
`;

let LegendStyles = props => css`
  display: inline-block;
  ${borderRadius(sizes.space * 0.25)};
  border: 1px solid ${tinycolor(props.theme.colors.secondary)
    .setAlpha(0.3)
    .toRgbString()};
  .rv-discrete-color-legend-item__title {
    ${typeSet(sizes.fontSize * 0.75)}
    color: ${props.theme.colors.secondary};
  }
`;
export let LegendStyled = styled("div")`
  ${LegendStyles}
`;

export class Graph extends React.Component {
  render() {
    return <GraphStyled id={this.props.id}>{this.props.children}</GraphStyled>;
  }
}

export class LineGraph extends React.Component {
  constructor(props) {
    super(props);
    this.resizeFn = this.handleResize.bind(this);
    this.state = { graphWidth: 500 };
  }

  componentDidMount() {
    window.addEventListener("resize", this.resizeFn);
    setTimeout(
      function() {
        this.handleResize();
      }.bind(this),
      200
    );
  }

  handleResize(WindowSize, event) {
    this.setState({
      graphWidth: Math.max($("#project-timeline").width(), 600)
    });

    console.log("graphWidth", this.state.graphWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFn);
  }

  render() {
    const colorScale = chroma
      .scale([this.props.colorPrimary, this.props.colorSecondary])
      .mode("lab");
    const graphsCount = this.props.data.length;
    console.log(graphsCount);

    const lineStyes = ["", "2 1", "3 3", "4 2", "3 3 2 3", "2 2 2 2 2 4"];
    return (
      <Graph id={this.props.id}>
        <XYPlot
          xType="time"
          yDomain={[0, 100]}
          width={this.state.graphWidth}
          height={152}
          margin={{right: 15}}
        >
          <GradientDefs>
            {this.props.data.map((graph, index) => (
              <linearGradient id={"graph_" + index} x1="0" x2="0" y1="0" y2="1">
                <stop
                  offset="0%"
                  stopColor={colorScale(index / graphsCount)}
                  stopOpacity={0.4}
                />
                <stop
                  offset="100%"
                  stopColor={colorScale(index / graphsCount)}
                  stopOpacity={0}
                />
              </linearGradient>
            ))}
          </GradientDefs>
          <VerticalGridLines />
          <XAxis />
          <YAxis />

          {this.props.data.map((graph, index) => (
            <AreaSeries
              name="Branding"
              color={"url(#graph_" + index + ")"}
              stroke={colorScale(index / graphsCount)}
              curve={"curveNatural"}
              className={"line-chart-area"}
              style={{ strokeDasharray: lineStyes[index] }}
              data={graph.data}
            />
          ))}
        </XYPlot>
      </Graph>
    );
  }
}

export class Legend extends React.Component {
  render() {
    const colorScale = chroma
      .scale([this.props.colorPrimary, this.props.colorSecondary])
      .mode("lab");
    const graphsCount = this.props.data.length;
    const lineStyes = ["", "2 1", "3 3", "4 2", "3 3 2 3", "2 2 2 2 2 4"];

    let legendItem = {};
    let legend = [];

    for (var index = 0; index < this.props.data.length; index++) {
      legendItem = {
        title: this.props.data[index].name,
        strokeWidth: 2,
        color: colorScale(index / graphsCount),
        strokeDasharray: lineStyes[index]
      };
      legend.push(legendItem);
    }

    return (
      <Graph>
        <LegendStyled>
          <DiscreteColorLegend orientation="horizontal" items={legend} />
        </LegendStyled>
      </Graph>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Partials/Graphs.js